import React from "react";

const Java_println = () => {
  return (
    <div>
      <h1>Java println()</h1>
      <p>This page provides explanations, examples, and common use-cases for Java println() in Java.</p>
    </div>
  );
};

export default Java_println;
